import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux/es/exports";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import ModalPrice from "../../components/product/ModalPrice";
import { BsArrowBarRight, BsArrowLeft } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import DeleteButton from "../../components/DeleteButton";
import { createUnits } from "../../services/unitService";
import Select from "../../components/Select";
import Pagination from "../../components/Pagination";
import { deleteFilling } from "../../services/fillingService";
import { toast } from "react-toastify";
import EditButton from "../../components/EditButton";
import TableComponent from "../../components/tableComponent/tableComponent";

const headerTable = [
  { name: "textures" },
  { name: "date" },
  { name: "price" },
  { name: "actions" },
];

const bodyTable = ["colors", "date", "price", "actions"];

function PriceLayout() {
  const [rowId, setRowId] = useState(null);
  const { token } = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [item, setItem] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [itemOffset, setItemOffset] = useState(0);
  const [forcePage, setForcePage] = useState(0);
  const [data, setData] = useState({
    data: [],
    recordsTotal: 0,
    pageCount: 1,
  });
  const { id } = useParams();
  const { name } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const fetchData = async () => {
    const response = await createUnits(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/price/table`,
      token,
      {
        draw: 1,
        start: itemOffset,
        length: itemsPerPage,
        recordsTotal: 0,
        columns: [],
        order: [],
        search: { value: "", regex: true },
        filter: { productId: id },
      }
    );
    if (response.success) {
      setIsLoading(false);
      let reviewData = response.data.data.map((item, index) => {
        return {
          colors: (
            <div className="flex items-center">
              <div>{item.textureName}</div>
              <div className="ml-3">
                {item.imageId ? (
                  <img
                    className="object-cover w-6 h-6 rounded-full"
                    src={`${process.env.REACT_APP_HOST_BASE_URL}/v1/file/texture/${item.imageId}`}
                    alt={"img"}
                  />
                ) : (
                  <div
                    style={{ backgroundColor: `${item.color}` }}
                    className={`py-1 rounded-lg text-white px-2`}
                  >
                    {item.color}
                  </div>
                )}
              </div>
            </div>
          ),
          ...item,
          actions: (
            <div className="flex">
              <EditButton onclick={() => updateHandler(item.id)} />
              <DeleteButton onclick={() => onDeleteItem(item.id)} />
            </div>
          ),
        };
      });
      setData({
        data: reviewData,
        recordsTotal: response.data.recordsFiltered,
        pageCount: Math.ceil(
          response.data.recordsFiltered / parseInt(itemsPerPage)
        ),
      });
    } else {
      setIsLoading(false);
      navigate("/error", {
        state: {
          status: response.status,
          message: response.message ? response.message : null,
        },
      });
    }
  };
  const updateHandler = (id) => {
    setRowId(id);
    setOpen(true);
  };
  const onDeleteItem = async (id) => {
    const responseReceived = await swal({
      title: t(`action.delete_item.title`),
      text: t(`action.delete_item.text`),
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: true,
      },
    });
    if (responseReceived) {
      setIsLoading(true);
      const response = await deleteFilling(
        `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/price/${id}`,
        token
      );
      if (response.success) {
        setIsLoading(false);
        fetchData();
        toast.success(t("action.delete_success"), {
          position: "bottom-right",
          autoClose: 3000,
          closeOnClick: true,
          className: "add-success",
        });
      } else {
        setIsLoading(false);
        navigate("/error", {
          state: {
            status: response.status,
            message: response.message ? response.message : null,
          },
        });
      }
    } else {
      return;
    }
  };

  useEffect(() => {
    fetchData();
  }, [itemOffset, itemsPerPage, data.recordsTotal]);

  const handlePageClick = (event) => {
    setForcePage(event.selected);
    const newOffset =
      (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
    setItemOffset(newOffset);
  };

  return (
    <>
      <ModalPrice
        productId={id}
        productName={name}
        rowId={rowId}
        open={open}
        setOpen={setOpen}
        fetchData={fetchData}
      />
      <div className="px-4 py-4 pt-10 sm:px-6 lg:px-8">
        <div>
          <button
            className="flex items-center justify-between mr-3 duration-300 ease-in-out hover:text-blue-900 hover:-translate-x-3"
            onClick={() => navigate(-1)}
          >
            <BsArrowLeft className="w-6 h-6 mr-8 hover:cursor-pointer" />
            <br />
            <br />
            <br />
            <div className="text-2xl font-semibold">{name}</div>
          </button>
        </div>
        <div className="mb-2 sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold text-gray-900">
              {t("table.product_price")}
            </h1>
          </div>
          <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
            <button
              className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
              onClick={() => {
                setItem(null);
                setOpen(true);
                setRowId(null)
              }}
            >
              {t("add_price")}
              <BsArrowBarRight className="w-6 h-6 ml-1 " />
            </button>
          </div>
        </div>
        {isLoading ? (
          <h1>Loading...</h1>
        ) : (
          <div>
            <Select
              setItemsPerPage={setItemsPerPage}
              itemsPerPage={itemsPerPage}
            />
            <TableComponent
              transactions={data.data}
              headerOfTable={headerTable}
              bodyOfTable={bodyTable}
              rowHandler={(id) => {
                const updatedData = data.data.map((item) => {
                  if (item.id === id) {
                    return {
                      ...item,
                      selected: true,
                    };
                  } else {
                    return {
                      ...item,
                      selected: false,
                    };
                  }
                });
                setData((prevState) => {
                  return {
                    ...prevState,
                    data: updatedData,
                  };
                });
              }}
            />
            <Pagination
              handlePageClick={handlePageClick}
              pageCount={data.pageCount}
              forcePage={forcePage}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default PriceLayout;
